import { Link } from "react-router-dom";

import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import ArtworkImage from "@/shared-components/cards/components/ArtworkImage";
import UserProfileImage from "@/shared-components/cards/components/UserProfileImage";
import Text from "@/shared-components/text/components/Text";

import "./styles/ChannelSliderCard.css";

export default function ChannelSliderCard({ channel, onVisit }) {
  const coverImage = channel.image || channel.coverImage || null;
  const ownerImage = channel.owner_image || channel.ownerImage || null;
  const ownerProfileType =
    channel.owner__t ||
    channel.owner_user_type ||
    channel.owner_type ||
    channel.ownerType ||
    channel.__t ||
    channel.user_type ||
    channel.owner?.__t ||
    channel.owner?.user_type ||
    channel.owner?.type ||
    "user";
  const title = channel.title || "Untitled channel";
  const ownerUsername =
    channel.owner_username ||
    channel.ownerUsername ||
    channel.owner?.user_username ||
    channel.user_username ||
    "";
  const membersCount = Number(channel.members_count ?? 0);
  const membersLabel = `${membersCount} member${membersCount === 1 ? "" : "s"}`;
  const channelKindRaw = (channel.channel_kind || channel.type || "").toString().trim();
  const channelKind = channelKindRaw
    ? channelKindRaw.replace(/[_\s]+/g, " ").trim().toUpperCase()
    : null;

  return (
    <div className="channel-card__container">
      <div className="channel-card__image-wrapper">
        {channelKind ? (
          <Text className="channel-card__kind font-size-small">{channelKind}</Text>
        ) : null}
        {coverImage ? (
          <ArtworkImage
            image={coverImage}
            imageClassName="channel-card__image"
            imageTemplateClassName="channel-card__image"
            style={{ aspectRatio: 16 / 10 }}
          />
        ) : (
          <div className="channel-card__no-image" aria-hidden="true" />
        )}
      </div>

      <div className="channel-card__info-row">
        <div className="channel-card__info-left">
          <Link
            className="channel-card__identity"
            to={`/user/${ownerUsername}`}
            onClick={(event) => event.stopPropagation()}
          >
            <UserProfileImage
              image={ownerImage}
              typeOfProfile={ownerProfileType}
              className="channel-card__owner-avatar"
            />
            <div className="channel-card__identity-text">
              <Text className="channel-card__title dots-on-overflow font-size-medium">
                {title}
              </Text>
              <Text className="channel-card__username dots-on-overflow font-size-small">
                {ownerUsername ? `@${ownerUsername} · ${membersLabel}` : membersLabel}
              </Text>
            </div>
          </Link>
        </div>

        <ContinueButton
          className="channel-card__button"
          onClick={(e) => {
            e.stopPropagation();
            onVisit?.();
          }}
          outline
        >
          <span className="channel-card__button-text--desktop">Join</span>
          <span className="channel-card__button-text--mobile">Join</span>
        </ContinueButton>
      </div>
    </div>
  );
}
